import { environment } from '@environments/environment';

const ALLOWED_AZURE_DOMAIN_LIST = {
  KLP: ['klp-dev.intellitech.no', 'klp.intellitech.no', 'is-admin-ui-prod.herokuapp.com', 'nc.klp.intellitech.no'],
  WTC: ['admin-dev.intellitech.no', 'localhost:4200', 'wtc.intellitech.no']
};
// 'wtc.intellitech.no'

export interface AzureConfig {
  clientID: string;
  loginUrl: string;
}

export function isAzureLoginAllowed(): boolean {
  let isAzureAllowed = false;

  Object.keys(ALLOWED_AZURE_DOMAIN_LIST).forEach(company => {
    if (ALLOWED_AZURE_DOMAIN_LIST[company].includes(window.location.host)) {
      isAzureAllowed = true;
    }
  });

  return isAzureAllowed;
}

export function fetchAzureConfig(): AzureConfig {
  let azureConfigId = 'azureKlp';

  if (ALLOWED_AZURE_DOMAIN_LIST.WTC.includes(window.location.host)) {
    azureConfigId = 'azureWatercircles';
  }

  return {
    clientID: environment[azureConfigId].clientID,
    loginUrl: environment[azureConfigId].loginUrl
  };
}
